document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('form[data-ajax-submit="true"]')

  forms.forEach((form) => {
    form.addEventListener('submit', function (e) {
      e.preventDefault()

      const submitBtn = form.querySelector('[type="submit"]')
      const originalBtnText = submitBtn ? submitBtn.value : 'Submit'
      const formData = new FormData(form)
      const formContainer = form.closest('.form')

      // Disable submit button and show processing state
      if (submitBtn) {
        submitBtn.disabled = true
        submitBtn.value = 'Sending...'
      }

      // Remove any existing messages
      const existingSuccess = formContainer.querySelector(
        '.ajax-success-message'
      )
      const existingError = formContainer.querySelector('.ajax-error-message')
      if (existingSuccess) existingSuccess.remove()
      if (existingError) existingError.remove()

      // Get CSRF token from the form or meta tag
      let csrfToken = ''
      const csrfInput = form.querySelector('input[name="CRAFT_CSRF_TOKEN"]')
      if (csrfInput) {
        csrfToken = csrfInput.value
      } else {
        // Fallback to meta tag if available
        const csrfMeta = document.querySelector('meta[name="csrf-token"]')
        if (csrfMeta) {
          csrfToken = csrfMeta.content
        }
      }

      // Add CSRF token to headers
      const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      }

      if (csrfToken) {
        headers['X-CRAFT-CSRF-TOKEN'] = csrfToken
      }

      // Get the form action URL (use getAttribute to avoid conflicts with form fields named "action")
      const formAction = form.getAttribute('action') || window.location.href
      
      // Submit form via AJAX
      fetch(formAction, {
        method: 'POST',
        body: formData,
        headers: headers,
      })
        .then((response) => {
          // Check if response is JSON or HTML
          const contentType = response.headers.get('content-type')

          if (contentType && contentType.includes('application/json')) {
            return response.json().then((data) => {
              if (data.success || data.finished) {
                return { success: true, returnUrl: data.returnUrl }
              } else if (data.errors) {
                throw { errors: data.errors }
              }
              return data
            })
          } else {
            // HTML response - check if it contains success indicators
            return response.text().then((html) => {
              // If we get a redirect or the form is no longer present, treat as success
              if (response.ok && !html.includes('freeform-form-has-errors')) {
                return { success: true }
              }
              throw new Error('Form submission failed')
            })
          }
        })
        .then((data) => {
          // Hide the form
          form.style.display = 'none'

          // Get custom success message from form data attribute
          const successMessage =
            form.getAttribute('data-success-message') ||
            'Thank you! Your form has been successfully submitted.'

          // Show success message
          const successDiv = document.createElement('div')
          successDiv.className = 'ajax-success-message'
          successDiv.innerHTML = `
          <div class="alert alert-success" style="padding: 20px; background-color: #d4edda; border: 1px solid #c3e6cb; border-radius: 4px; color: #155724; margin-top: 20px;">
            <h3 style="margin-bottom: 0;">${successMessage}</h3>
          </div>
        `
          form.parentNode.insertBefore(successDiv, form)

          // Scroll to success message
          successDiv.scrollIntoView({ behavior: 'smooth', block: 'center' })

          // Reset form for potential future use
          form.reset()
        })
        .catch((error) => {
          console.error('Form submission error:', error)

          // Re-enable submit button
          if (submitBtn) {
            submitBtn.disabled = false
            submitBtn.value = originalBtnText
          }

          // Get custom error message from form data attribute
          const errorMessage =
            form.getAttribute('data-error-message') ||
            'Error! There was a problem submitting the form. Please try again.'

          // Show error message
          const errorDiv = document.createElement('div')
          errorDiv.className = 'ajax-error-message'
          errorDiv.innerHTML = `
          <div class="alert alert-danger" style="padding: 15px; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px; color: #721c24; margin-bottom: 20px;">
            ${errorMessage}
          </div>
        `
          form.parentNode.insertBefore(errorDiv, form)

          // Auto-remove error message after 5 seconds
          setTimeout(() => {
            if (errorDiv.parentNode) {
              errorDiv.remove()
            }
          }, 5000)
        })
    })
  })
})
